module.exports = __webpack_public_path__ + "media/reference1.94aab841.mp3";